import {createApp} from "vue";
import i18n from "../plugins/i18n";
import {PfcDetailIconTooltip} from '@webstacz/shop-components';
import {PfcReviewInfo} from '@webstacz/shop-components';
import {initTrustedShops} from "./components/trusted-shops";

export const scrollToReviews = function () {
    const reviews = document.querySelector('.ce_customer-reviews')?.parentElement?.parentElement?.parentElement ?? null;

    if (reviews !== null) {
        let top = reviews.getBoundingClientRect().top
            + window.scrollY
            - (document.getElementById('header').clientHeight)
            - 30;

        window.scroll({
            top,
            behavior: 'smooth',
        })
    }
};

window.scrollToReviews = scrollToReviews;

const reviewLink = document.querySelector('.pfc-review-link');
if (reviewLink !== null) {
    reviewLink.addEventListener('click', (e) => {
        e.preventDefault();
        scrollToReviews();
    });
}


document.addEventListener('DOMContentLoaded', () => {
    const pfcDetailInfoIcon = document.getElementById('pfc-detail-info-icon');
    if (pfcDetailInfoIcon !== null) {
        const app = createApp({
            template: `<pfc-detail-icon-tooltip :title="title"/>`,
            setup() {
                return {
                    title: i18n.global.t('product-detail-assembly-price-tooltip').toString(),
                };
            },
            components: {
                PfcDetailIconTooltip,
            },
        });

        app.mount(pfcDetailInfoIcon);
    }
});

const pfcReviewEl = document.getElementById('pfc-review-info');

if (pfcReviewEl) {
    const tsLink = pfcReviewEl.dataset.tsLink;

    const app = createApp({
        template: `
            <PfcReviewInfo
                :ts-link="tsLink"
                :init-trusted-shops="initTrustedShops"
                :scroll-to-reviews="scrollToReviews"
            />
        `,
        components: {
            PfcReviewInfo,
        },
        setup() {
            return {
                tsLink,
                initTrustedShops: initTrustedShops,
                scrollToReviews: scrollToReviews,
            };
        },
    });

    app.use(i18n);
    app.mount(pfcReviewEl);
}


const pfcAddToCartBtn = jQuery('.pfc-detail-add-to-cart');

pfcAddToCartBtn.parents('form').submit(function(e) {
    pfcAddToCartBtn.attr('disabled', true);
});


/**
 * Product detail accordion
 */
jQuery(".ce_pfc-detail .acc > h5").on("click", function () {
    if (jQuery(window).width() < 1024) {
        jQuery(this).toggleClass('active');
        jQuery(this).next().stop().slideToggle();
    }
});
